import './App.css';
import { Routes, Route } from 'react-router-dom';

import { Container } from '@mui/material';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material/styles';
import { StyledEngineProvider } from '@mui/material/styles';
import { Box } from '@mui/system';

import 'react-toastify/dist/ReactToastify.css';
import * as Sentry from "@sentry/react";

import ResponsiveMenu from './components/navigation/ResponsiveMenu.js';
import ApplicationFooter from './components/navigation/ApplicationFooter.js';

import Home from './components/sections/app/Home';
import Login from './components/sections/app/Login';
import PageNotFound from './components/sections/app/PageNotFound';
import About from './components/sections/app/About';
import UserProfile from './components/sections/app/UserProfile';

import { HikoToastContainer } from './utils/HikoAlert';
import MahiErrorFallback from './components/navigation/MahiErrorFallback';
import AdminListUsers from './components/sections/admin/AdminListUsers';
import IcpInspection from './components/sections/connect/IcpInspection';
import IcpInspectionByWorkOrder from './components/sections/connect/IcpInspectionByWorkOrder';
import ConnectListIcpInspections from './components/sections/connect/ConnectListIcpInspections';
import ConnectIcpInspectionDetails from './components/sections/connect/ConnectIcpInspectionDetails';
import AdminListAccounts from './components/sections/admin/AdminListAccounts';
import QRTagDetails from './components/sections/tags/qrTagDetails';
import QRTagView from './components/sections/tags/qrTagView';
import QRTagEdit from './components/sections/tags/qrTagEdit';
import VegTreeDocs from './components/sections/vegetation/vegTreeDocs';
import ConnectRequestForInformationWithRefresh from './components/sections/connect/ConnectRequestForInformationWithRefresh';
import DlspSuburbTaskList from './components/sections/dlsp/DlspSuburbTaskList';
import DlspListStormAreas from './components/sections/dlsp/DlspListStormAreas';
import DlspStormAreaSuburbList from './components/sections/dlsp/DlspStormAreaSuburbList';
import DlspSearchTask from './components/sections/dlsp/DlspSearchTask';
import ProtectedRoute from './components/auth/ProtectedRouteWithVerify';
import DlspDesktopQATaskList from './components/sections/dlsp/DlspDesktopQATaskList';
import DlspTaskFieldInspection from './components/sections/dlsp/DlspTaskFieldInspection';
import DlspLandOwnerPermissionTaskList from './components/sections/dlsp/DlspLandOwnerPermissionTaskList';
import DlspFieldQATaskList from './components/sections/dlsp/DlspFieldQATaskList';
import AssetDocumentsWithRefresh from './components/sections/ni/AssetDocumentsWithRefresh';
import DlspRemedialTaskList from './components/sections/dlsp/DlspRemedialTaskList';
import DlspTaskDetailsWithRefresh from './components/sections/dlsp/DlspTaskDetailsWithRefresh';
import WairuaWeekly from './components/sections/wairua/WairuaWeekly';
const { styled } = require("@mui/material");
const routes = require('./config/routes.json');

//
// Override Material UI theme
//
let headerStyles = {
  color: '#e0521f', // Northpower Orange
  // fontFamily: '"Typ1451-Medium", sans-serif',
  '& small': {
    fontSize: '0.8em',
    lineHeight: '0.8em',
    fontVariant: 'small-caps',
  }
};

// let northpowerTheme = createTheme(adaptV4Theme({
let northpowerTheme = createTheme({
  palette: {
    primary: {
      main: '#e0521f', // Northpower Orange
    },
    secondary: {
      main: '#212829', // Northpower Dark Gray
    },
    // error
    // warning
    // info
    // success
    np_light_gray: {
      main: '#565a5c', // Northpower Light Gray
      dark: '#363a3c',
      light: '#767a7c',
    },
    nonprod: {
      main: '#b94690', // Mahi Non-Prod Purple. Can be used as {northpowerTheme.palette.nonprod.main}
    },
    bright: {
      main: '#ffffff', // So you can get white by saying color="bright"
    },
    statusIdle: {
      main: '#ffffff', // white
      contrastText: '#616263'
    },
    statusActive: {
      main: '#5b7ea8', // greyish blue
      contrastText: '#ffffff'
    },
    statusPaused: {
      main: '#ee7700', // dark orange
      contrastText: '#ffffff'
    },
    statusPending: {
      main: '#95a5a5', // light gray
      contrastText: '#ffffff'
    },
    statusComplete: {
      main: '#64a338', // palish green
      contrastText: '#ffffff'
    },
  },
  typography: {
    fontSize: 14, // 14 is the default
    h1: headerStyles,
    h2: headerStyles,
    h3: headerStyles,
    h4: headerStyles,
    h5: headerStyles,
    h6: headerStyles,
    subtitle1: {
      color: '#e0521f', // Northpower Orange
    },
    subtitle2: {
      color: '#e0521f', // Northpower Orange
    },
  },
});
// }));
northpowerTheme = responsiveFontSizes(northpowerTheme);

const StyledContainer = styled(Container)(({theme}) => {
    return ({
        [theme.breakpoints.down('md')]: {
          paddingLeft: '12px',
          paddingRight: '12px',
        },
        [theme.breakpoints.down('sm')]: {
          paddingLeft: '6px',
          paddingRight: '6px',
        },
    })
})

export default function App() {

  // const isRootUrl = window.location.pathname === '/'

  // console.log('App.js window.location', window.location)
  // console.log('App.js isRootUrl', isRootUrl)

  // const isAuthenticated = useIsAuthenticated();
  // const { pathname, search } = useLocation();
  // console.log('APP returning a ROUTE with pathname, search, isAuthenticated', pathname, search, isAuthenticated);

  // console.log('[APP] rendering pathname, search', pathname, search); 
  // console.log('APP routes from json', routes);

  // const counter = useRef(0);
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={northpowerTheme}>
        <StyledContainer className="App">
          <HikoToastContainer />
          <ResponsiveMenu />

          <Box sx={{pt: 2, pb: 6, minHeight: '80vh'}}>
            {/* <p>App render {counter.current++}</p> */}
            <Sentry.ErrorBoundary fallback={MahiErrorFallback}>
              <Routes>
                <Route path={routes.home.href} roles={routes.home.requiresRole}
                  element={<Home />} />
                <Route path={routes.about.href}
                  element={<ProtectedRoute roles={routes.about.requiresRole}><About /></ProtectedRoute>} />
                {/* Admin */}
                <Route path={routes.adminListUsers.href}
                  element={<ProtectedRoute roles={routes.adminListUsers.requiresRole}><AdminListUsers /></ProtectedRoute>} />
                <Route path={routes.adminListAccounts.href}
                  element={<ProtectedRoute roles={routes.adminListAccounts.requiresRole}><AdminListAccounts /></ProtectedRoute>} />
                {/* Connect */}
                <Route path={routes.connectRequestForInformation.href}
                  element={<ProtectedRoute roles={routes.connectRequestForInformation.requiresRole}><ConnectRequestForInformationWithRefresh /></ProtectedRoute>} />
                <Route path={routes.connectListIcpInspections.href}
                  element={<ProtectedRoute roles={routes.connectListIcpInspections.requiresRole}><ConnectListIcpInspections /></ProtectedRoute>} />
                <Route path={routes.connectIcpInspectionDetails.href}
                  element={<ProtectedRoute roles={routes.connectIcpInspectionDetails.requiresRole}><ConnectIcpInspectionDetails /></ProtectedRoute>} />
                <Route path={routes.icpInspection.href}
                  element={<ProtectedRoute roles={routes.icpInspection.requiresRole}><IcpInspection /></ProtectedRoute>} />
                <Route path={routes.icpInspectionByWorkOrder.href}
                  element={<ProtectedRoute roles={routes.icpInspectionByWorkOrder.requiresRole}><IcpInspectionByWorkOrder /></ProtectedRoute>} />
                {/* Tags */}
                <Route path={routes.tagView.href /* Tag View does not require login */}
                  element={<QRTagView />} />
                <Route path={routes.tagDetails.href}
                  element={<ProtectedRoute roles={routes.tagDetails.requiresRole}><QRTagDetails /></ProtectedRoute>} />
                <Route path={routes.tagEdit.href}
                  element={<ProtectedRoute roles={routes.tagEdit.requiresRole}><QRTagEdit /></ProtectedRoute>} />
                {/* Vegetation */}
                <Route path={routes.vegTreeDocs.href}
                  element={<ProtectedRoute roles={routes.vegTreeDocs.requiresRole}><VegTreeDocs /></ProtectedRoute>} />
                {/* Network */}
                <Route path={routes.niAssetDocs.href}
                  element={<ProtectedRoute roles={routes.niAssetDocs.requiresRole}><AssetDocumentsWithRefresh /></ProtectedRoute>} />

                {/* DLSP */}
                <Route path={routes.dlspListStormAreas.href}
                  element={<ProtectedRoute roles={routes.dlspListStormAreas.requiresRole}><DlspListStormAreas /></ProtectedRoute>} />
                <Route path={routes.dlspSearchTask.href}
                  element={<ProtectedRoute roles={routes.dlspSearchTask.requiresRole}><DlspSearchTask /></ProtectedRoute>} />
                <Route path={routes.dlspStormAreaSuburbList.href}
                  element={<ProtectedRoute roles={routes.dlspStormAreaSuburbList.requiresRole}><DlspStormAreaSuburbList /></ProtectedRoute>} />
                <Route path={routes.dlspSuburbTaskList.href}
                  element={<ProtectedRoute roles={routes.dlspSuburbTaskList.requiresRole}><DlspSuburbTaskList /></ProtectedRoute>} />
                <Route path={routes.dlspDesktopQATaskList.href}
                  element={<ProtectedRoute roles={routes.dlspDesktopQATaskList.requiresRole}><DlspDesktopQATaskList /></ProtectedRoute>} />
                <Route path={routes.dlspLandOwnerPermissionTaskList.href}
                  element={<ProtectedRoute roles={routes.dlspLandOwnerPermissionTaskList.requiresRole}><DlspLandOwnerPermissionTaskList /></ProtectedRoute>} />
                <Route path={routes.dlspFieldQATaskList.href}
                  element={<ProtectedRoute roles={routes.dlspFieldQATaskList.requiresRole}><DlspFieldQATaskList /></ProtectedRoute>} />
                <Route path={routes.dlspRemedialTaskList.href}
                  element={<ProtectedRoute roles={routes.dlspRemedialTaskList.requiresRole}><DlspRemedialTaskList /></ProtectedRoute>} />
                <Route path={routes.dlspTaskDetails.href}
                  element={<ProtectedRoute roles={routes.dlspTaskDetails.requiresRole}><DlspTaskDetailsWithRefresh /></ProtectedRoute>} />
                <Route path={routes.dlspTaskFieldInspection.href}
                  element={<ProtectedRoute roles={routes.dlspTaskFieldInspection.requiresRole}><DlspTaskFieldInspection /></ProtectedRoute>} />

                {/* Wairua */}
                <Route path={routes.wairuaWeekly.href}
                  element={<ProtectedRoute roles={routes.wairuaWeekly.requiresRole}><WairuaWeekly /></ProtectedRoute>} />

                {/* Profile */}
                <Route path={routes.profile.href}
                  element={<ProtectedRoute roles={routes.profile.requiresRole}><UserProfile /></ProtectedRoute>} />
                <Route path="/login"
                  element={<Login />} />
                <Route path="*"
                  element={<PageNotFound />} />
              </Routes>
            </Sentry.ErrorBoundary>
          </Box>


        </StyledContainer>
        <ApplicationFooter />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}



